module.exports = __webpack_public_path__ + "static/img/about_h5banner_01_zh.c7c1598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5banner_01_zh.png
// module id = /LJ7
// module chunks = 34